import { TmsUserFeaturePermissions } from '@constants'

import { FeaturePermissons, permissionDeniedForUser } from '@permissions'

import { isAdminOrAccountant } from './authorization'

type AvailableFeatures =
  | FeaturePermissons.ACCOUNTING_ID
  | FeaturePermissons.ADVANCED_ACCOUNTING
  | FeaturePermissons.REQUIRE_APPROVAL_FOR_PAYMENT
  | FeaturePermissons.VAT_PERIOD

//* Company advanced settings
function isCompanySettingEnabled(state: Store | Company, feature: AvailableFeatures, isCompanyState = false) {
  if (isCompanyState) return (state as Company)?.[feature] ?? false
  return (state as Store).auth.company.data?.[feature] ?? false
}

export function isAdvancedAccountingAvailableForUser(state: Store) {
  return (
    isCompanySettingEnabled(state, FeaturePermissons.ADVANCED_ACCOUNTING) &&
    !permissionDeniedForUser(state, TmsUserFeaturePermissions.denyAccountingPermission)
  )
}

export function isRequireApprovalForPaymentEnabled(state: Store) {
  return isCompanySettingEnabled(state, FeaturePermissons.REQUIRE_APPROVAL_FOR_PAYMENT)
}

export function userHasAccountantRole(state: Store) {
  return (
    isAdminOrAccountant(state.auth.company.data.role) &&
    !permissionDeniedForUser(state, TmsUserFeaturePermissions.denyAccountingPermission)
  )
}

export function isAccountingFetaureEnabledForUser(
  state: Store,
  feature: FeaturePermissons.ACCOUNTING_ID | FeaturePermissons.VAT_PERIOD
) {
  return userHasAccountantRole(state) && isCompanySettingEnabled(state, feature)
}
